module.exports = require('../../es/object/assign');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/features/object/assign.js
// module id = 187
// module chunks = 0